import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class CloseButton extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  shouldComponentUpdate() {
    return false
  }

  handleClick(e) {
    e.preventDefault()
    this.props.onClick(e)
  }

  render() {
    return (
      <button
        className="close"
        dangerouslySetInnerHTML={{ __html: '&times;' }}
        onClick={this.handleClick}
      />
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/buttons/CloseButton.js